<div class="onoffswitch">
    <input type="checkbox" class="onoffswitch-checkbox" [checked]="enabled" disabled>
    <label class="onoffswitch-label"></label>
</div>
